import React from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-lg mt-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Om denna sida</h1>
      
      <div className="prose prose-lg text-gray-700 space-y-4">
        <p>
          Som ålänning som bott i Sverige fick jag ibland höra att jag pratar väldigt bra svenska för att inte vara från Sverige. 
          Jovisst - tack det är mitt modersmål!
        </p>

        <p>
          Den här sidan skapar jag för att på ett visuellt sätt tydliggöra svensk historia och de delar som genom tiderna har tillhört Sverige. 
          Kanske kan det ge en viss förståelse för att Åland är enspråkigt svenskt fortfarande i nutid?
        </p>

        <p>
          Och om inte annat har det varit ett intressant projekt att genomföra och har lett till att jag har läst på mer om nordisk historia.
        </p>

        <p>
          Hoppas att den gett er något!
        </p>

        <p className="mt-8">
          Hälsningar,<br />
          Andreas från Åland <span className="text-2xl">🇦🇽</span>
        </p>

        <div className="mt-12 pt-6 border-t border-gray-200">
          <Link 
            to="/" 
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            &larr; Tillbaka till kartan
          </Link>
        </div>
      </div>
    </div>
  );
}
